import { MutationTree } from "vuex";
import { SettingsState } from "../types";

const mutations: MutationTree<SettingsState> = {};

export default mutations;
